<template>
  <nav class="nav-sidebar" role="navigation" aria-label="Main navigation">

    <img
        style="margin-bottom: 16px"
        loading="lazy"
        src="/assets/urs_logo.png"
        class="logo"
        alt="Company logo"
    />
    <div style="align-self: stretch">
      <ul class="nav-menu">
        <NavItem
            :active="item.id === active"
            v-for="item in navItems"
            :key="item.id"
            :item="item"
        />
      </ul>
    </div>

    <div class="">
      <NavItem
          :item="{
          id: 0,
          title: 'Account name',
          prefixActive: '/assets/logout.svg',
          prefixDeActive: '/assets/logout.svg',
          to: 'login',
          action: logout
        }"
      />

    </div>
  </nav>
</template>
<style>
.account-menu {
  margin-top: auto; /* Push the element to the end of the parent container */
}
.nav-menu {
  display: flex;
  flex-direction: column;
  align-items: center; /* Center-align children vertically */
}
.nav-sidebar {
  border-radius: 24px;
  background-color: rgba(247, 248, 252, 1);
  box-shadow: 0px 0px 22px rgba(94, 94, 94, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  align-items: center;
  width: 89px;
  height: 96vh;
  padding: 25px 10px;
  justify-content: space-between; /* Evenly space child elements */
}
.logo {
  aspect-ratio: 2.19;
  height: 149px;
  object-fit: contain;
  object-position: center;
  width: 100%;
  align-self: stretch;
}
@media (max-width: 991px) {
  .nav-sidebar {
    display: none;
  }
}
</style>
<script lang="ts">
import NavItem from "./NavItem.vue";
import {defineComponent} from 'vue';
import { useAuth } from '../composables/useAuth';


interface NavItemType {
  id: number;
  title: string;
  prefixActive: string;
  prefixDeActive: string;
  to?: string;
  suffix?: string;
}

export default defineComponent({
  name: "SideNavigation",
  components: {
    NavItem,
  },
  props: {
    active: {
      type: Number,
      default: 1,
    },
  },
  setup() {
    const { logout,isManager } = useAuth();

    let navItems: NavItemType[] = [
      {
        id: 1,
        title: "Dashboard",
        prefixActive: "/assets/dashboard_vector_activate.svg",
        prefixDeActive: "/assets/dashboard_vector_deactivate.svg",
        to: "home"
      },
      {
        id: 2,
        title: "Profiles",
        prefixActive: "/assets/profile_vector_activate.svg",
        prefixDeActive: "/assets/profile_vector.svg",
        to: "management"
      },
      {
        id: 3,
        title: "Security",
        prefixActive: "/assets/servers_vector.svg",
        prefixDeActive: "/assets/servers_vector.svg",
      },
      {
        id: 4,
        title: "Support",
        prefixActive: "/assets/support_vector.svg",
        prefixDeActive: "/assets/support_vector.svg",
      },
      {
        id: 5,
        title: "Settings",
        prefixActive: "/assets/setting_vector.svg",
        prefixDeActive: "/assets/setting_vector.svg",
      },
    ];
    if(!isManager()){
      navItems = [
        {
          id: 1,
          title: "Dashboard",
          prefixActive: "/assets/dashboard_vector_activate.svg",
          prefixDeActive: "/assets/dashboard_vector_deactivate.svg",
          to: "home"
        },
        {
          id: 2,
          title: "Security",
          prefixActive: "/assets/servers_vector.svg",
          prefixDeActive: "/assets/servers_vector.svg",
        },
        {
          id: 3,
          title: "Support",
          prefixActive: "/assets/support_vector.svg",
          prefixDeActive: "/assets/support_vector.svg",
        },
        {
          id: 4,
          title: "Settings",
          prefixActive: "/assets/setting_vector.svg",
          prefixDeActive: "/assets/setting_vector.svg",
        },
      ];

    }
    return {
      navItems,
      logout,
    };
  },
});
</script>
